module.exports = __webpack_public_path__ + "img/erp_p1_img.8c510679.png";